export default "__VITE_ASSET__BRtVPgAs__"